module.exports = __webpack_public_path__ + "img/111.720367f0.jpg";